import React from "react";
import "./dashboard_view_dashboard.css";
import Search_total_project from "../search-total-project/Search_total_project";
import { Link } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { ProgressBar } from "react-bootstrap";
import Section_title from "../../common-components/section-title/Section_title";
import Filter_by from "../../common-components/filter-by/Filter_by";

const Dashboard_view_dashboard = () => {
  return (
    <>
      <section className="Dashboard_main_sec_view">
        <div className="innersectionflex">
          <div className="countrybox">
            <div className="section_box">
              <p className="blue_heading mb-0">Dashboard</p>
              <div className="row mainrow mt-2">
                <div className="col-md-4 mb-3 form-group">
                  <div className="left_side">
                    <div className="spinner_card">
                      <div className="content">
                        <div className="text">
                          <p>Projects under warranty</p>
                        </div>
                        <div className="spinner_holder first">
                          <div className="progress-holder">
                            <CircularProgressbar value="11" text="11%" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="spinner_card">
                      <div className="content">
                        <div className="text">
                          <p>Rental Installations</p>
                        </div>
                        <div className="spinner_holder second">
                          <div className="progress-holder">
                            <CircularProgressbar value="22" text="22%" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="spinner_card">
                      <div className="content">
                        <div className="text">
                          <p>Ongoing Installations</p>
                        </div>
                        <div className="spinner_holder third">
                          <div className="progress-holder">
                            <CircularProgressbar value="45" text="45%" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="spinner_card">
                      <div className="content">
                        <div className="text">
                          <p>Under AMC</p>
                        </div>
                        <div className="spinner_holder fourth">
                          <div className="progress-holder">
                            <CircularProgressbar value="22" text="22%" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="maindiv">
                    <div className="right_side">
                      <div className="graph">
                        <div className="row">
                          <div className="col-3">
                            <div className="month">
                              <p>Ongoing Installations</p>
                            </div>
                          </div>
                          <div className="col-9">
                            <div className="progressbar-div first">
                              <ProgressBar>
                                <ProgressBar
                                  striped
                                  variant="success"
                                  now={40}
                                  key={1}
                                />
                                <ProgressBar
                                  variant="warning"
                                  now={20}
                                  key={2}
                                />
                                <ProgressBar
                                  striped
                                  variant="info"
                                  now={10}
                                  key={3}
                                />
                              </ProgressBar>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <div className="month">
                              <p>Under AMC</p>
                            </div>
                          </div>
                          <div className="col-9">
                            <div className="progressbar-div second">
                              <ProgressBar>
                                <ProgressBar
                                  striped
                                  variant="success"
                                  now={30}
                                  key={1}
                                />
                                <ProgressBar
                                  variant="warning"
                                  now={20}
                                  key={2}
                                />
                                <ProgressBar
                                  striped
                                  variant="danger"
                                  now={10}
                                  key={3}
                                />
                              </ProgressBar>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <div className="month">
                              <p>Rental Installations</p>
                            </div>
                          </div>
                          <div className="col-9">
                            <div className="progressbar-div third">
                              <ProgressBar>
                                <ProgressBar
                                  striped
                                  variant="success"
                                  now={50}
                                  key={1}
                                />
                                <ProgressBar
                                  variant="warning"
                                  now={20}
                                  key={2}
                                />
                                <ProgressBar
                                  striped
                                  variant="danger"
                                  now={10}
                                  key={3}
                                />
                              </ProgressBar>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-3">
                            <div className="month">
                              <p>Projects Under Warranty</p>
                            </div>
                          </div>
                          <div className="col-9">
                            <div className="progressbar-div fourth">
                              <ProgressBar>
                                <ProgressBar
                                  striped
                                  variant="success"
                                  now={45}
                                  key={1}
                                />
                                <ProgressBar
                                  variant="warning"
                                  now={20}
                                  key={2}
                                />
                                <ProgressBar
                                  striped
                                  variant="danger"
                                  now={25}
                                  key={3}
                                />
                              </ProgressBar>
                            </div>
                          </div>
                          <div className="row number-row">
                            <div className="col-4"></div>
                            <div className="col-8">
                              <div className="numbers">
                                <div className="number">
                                  <p>05</p>
                                </div>
                                <div className="number">
                                  <p>10</p>
                                </div>
                                <div className="number">
                                  <p>15</p>
                                </div>
                                <div className="number">
                                  <p>20</p>
                                </div>
                                <div className="number">
                                  <p>25</p>
                                </div>
                                <div className="number">
                                  <p>30</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="lastrow">
                      <div className="main-info-holder">
                        <div className="info ">
                          <div className="bg-blue"></div>
                          <div className="name">Material</div>
                        </div>
                        <div className="info">
                          <div className="bg-orange"></div>
                          <div className="name">Travel</div>
                        </div>
                        <div className="info">
                          <div className="bg-red"></div>
                          <div className="name">Accommodation</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="totalprojectsidebar">
            <div className="right_sidebar">
              <Search_total_project />
              <br></br>
              <br></br>
              <div className="listdashbtn_div">
                <div className="btngroup">
                  <Link to="/">
                    <button className="listbtn">Map View</button>
                  </Link>
                </div>
                <div className="btngroup">
                  <Link to="/list-view">
                    <button className="dashbtn theme_bg">View List</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard_view_dashboard;
